import React from 'react';
import Filter from './mainJS/filter';
//import MobileMenu from './mainJS/mobile-menu';
import './mainCSS/style.css';
import ReactDOM from "react-dom";

/*export default function App() {
  return (
    <Filter />
  );
}*/

export default function App() {
  //<input id='search' onKeyDown={site.searchRead()} type='text' placeholder={' keresés / termék névre'} alt={'Keresés a szexshop termékei között'} />
  //<input onclick={site.search()} value='' type='submit' />
  //<div class='hit'></div>
  return (
    <div>
    </div>
  );
}

/*function mobileMenu() {
  //Menu data downloads
  setTimeout(function () {
    ReactDOM.render(
      <MobileMenu />,
      document.getElementById("menu-line")
    );
  }, 10);
}*/

function filterShow() {
  setTimeout(function () {
    ReactDOM.render(
      <Filter />,
      document.getElementById("filter")
    );
  }, 10);
}

//mobileMenu();

filterShow();